<template lang="">
  <b-modal
    id="file-input-modal"
    ref="urlInputModal"
    class="static-modal"
    :modal-class="{preloading: false, 'hide-send': false }"
    title-class="flex flex-align-center"
    :body-class="['top-margin-first-child', { 'no-bottom-padding': false }]"
    size="xl"
    :lazy="true"
    no-close-on-backdrop
    hide-header-close
    centered
    scrollable
    @hidden="clear">
    <template slot="modal-header" >
      <div>
        <h3>{{ modalTitle }}</h3>
        <div class="subtitle flex flex-align-center">
          <SBIcon
            class="mr-1"
            :icon="SBIconList.INFO"
            :color="SBColors.greyLight"
            :size="10" />
          <p>{{ modalSubtitle }}</p>
        </div>
      </div>
    </template>

    <!-- MODAL BODY -->
    <RadioButtons
      v-model="radioSelected.value"
      :options="radioSelected.options"
      :mark-selected="false"
      :marked-items="markedItems" />
    <Dropdown
      v-model="rescrape.value"
      :options="rescrape.options"
      :required="true"
      :title="rescrape.title"
      :info="rescrape.info" />

    <Divider />
    <!-- This span is here just to prevent divider getting zero bottom margin when its next sibling gets display: none. -->
    <span />

    <!-- Entire web view -->
    <Input
      v-show="radioSelected.value === 1"
      ref="entireWebInputRef"
      v-model="entireWeb.value"
      :title="entireWeb.title"
      :validators="entireWebValidators"
      :info="entireWeb.info"
      :placeholder="entireWeb.placeholder"
      :action="showEntireWebAction ? entireWeb.action : null"
      @status="setStatus($event, 'entireWeb')" />
    <WarningBubble
      v-if="radioSelected.value === 1 && elements.info && elements.info.message"
      :message="elements.info.message" />
    <div v-show="radioSelected.value === 1">
      <Title
        v-b-toggle.collapse-filters
        title="Filters"
        collapsable
        :collapsed="collapsed" />
      <b-collapse
        id="collapse-filters"
        class="top-margin-first-child" >
        <ButtonList
          v-model="includeLinksList.value"
          :title="includeLinksList.title"
          :enter="includeLinksList.enter"
          :subtitle="includeLinksList.subtitle"
          :add-button-text="includeLinksList.addButtonText"
          :placeholder="includeLinksList.placeholder"
          :validators="includeLinksList.validators+'|externalUniques'"
          :validator-messages="includeLinksList.validatorMessages"
          :external-uniques="excludeLinksList.value"
          :min-buttons="includeLinksList.minButtons"
          :max-buttons="includeLinksList.maxButtons"
          @status="setStatus($event, 'includeLinksList')" />
        <ButtonList
          v-model="excludeLinksList.value"
          :title="excludeLinksList.title"
          :enter="excludeLinksList.enter"
          :subtitle="excludeLinksList.subtitle"
          :add-button-text="excludeLinksList.addButtonText"
          :placeholder="excludeLinksList.placeholder"
          :validators="excludeLinksList.validators+'|externalUniques'"
          :validator-messages="excludeLinksList.validatorMessages"
          :external-uniques="includeLinksList.value"
          :min-buttons="excludeLinksList.minButtons"
          :max-buttons="excludeLinksList.maxButtons"
          @status="setStatus($event, 'excludeLinksList')" />
      </b-collapse>
    </div>

    <Divider
      v-if="showEntireWebScrape && elements.url.value" />

    <RemoteData
      v-if="entireWebScrapePagination.endpoint && elements.url.value"
      v-show="showEntireWebScrape"
      v-model="entireWebScrapePagination.value"
      :title="entireWebScrapePagination.title"
      :endpoint="entireWebScrapePagination.endpoint"
      :search-tag="entireWebScrapePagination.searchTag"
      :remote-data-key="entireWebScrapePagination.remoteDataKey"
      :count="entireWebScrapePagination.count"
      :total="entireWebScrapePagination.maxLinks"
      :read-only="entireWebScrapePagination.readOnly"
      no-scraped-data-message="There are no scraped pages." />

    <!-- Specific links view -->
    <ButtonList
      v-show="radioSelected.value === 2"
      v-model="specificLinksList.value"
      :title="specificLinksList.title"
      :enter="specificLinksList.enter"
      :subtitle="specificLinksList.subtitle"
      :add-button-text="specificLinksList.addButtonText"
      :placeholder="specificLinksList.placeholder"
      :validators="specificLinksList.validators"
      :validator-messages="specificLinksList.validatorMessages"
      :min-buttons="specificLinksList.minButtons"
      :max-buttons="specificLinksList.maxButtons"
      @status="setStatus($event, 'specificLinksList')" />
    <RemoteData
      v-if="specificScrapePagination.endpoint"
      v-show="specificScrapePagination.count &&
        (!specificScrapePagination.value || (specificScrapePagination.value && (specificScrapePagination.count - specificScrapePagination.value.length) > 0)) &&
        radioSelected.value === 2"
      v-model="specificScrapePagination.value"
      :title="specificScrapePagination.title"
      :endpoint="specificScrapePagination.endpoint"
      :search-tag="specificScrapePagination.searchTag"
      :remote-data-key="specificScrapePagination.remoteDataKey"
      :count="specificScrapePagination.count"
      :total="specificScrapePagination.maxLinks"
      :read-only="specificScrapePagination.readOnly" />
    <!-- MODAL BODY end-->

    <template slot="modal-footer">
      <b-button
        :class="{loading: false}"
        :disabled="false"
        @click="cancel">
        <span>Cancel</span>
        <div
          class="loader-15 black"
        ><div class="loading-circle"/></div>
      </b-button>
      <b-button
        variant="primary"
        :class="{loading: false}"
        :disabled="!allValid || !edited"
        @click="emitData" >
        <span>Done</span>
        <div
          class="loader-15 black"
        ><div class="loading-circle"/></div>
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import ToasterMixin from '@/mixins/Toaster';
import RadioButtons from '@/components/formElements/RadioButtons.form';
import Divider from '@/components/formElements/Divider.form';
import Dropdown from '@/components/formElements/Dropdown.form';
import Input from '@/components/formElements/Input.form';
import RemoteData from '@/components/formElements/RemoteData.form';
import ButtonList from '@/components/formElements/ButtonList.form';
import Title from '@/components/formElements/Title.form';
import WarningBubble from '@/components/common/widgets/WarningBubble';

export default {
  name: 'UrlInputModal',
  components: {
    SBIcon,
    RadioButtons,
    Divider,
    Dropdown,
    Input,
    RemoteData,
    ButtonList,
    Title,
    WarningBubble,
  },
  mixins: [
    ToasterMixin,
  ],
  props: {
    count: {
      type: Number,
      required: false,
      default: 0,
    },
    elements: {
      type: Object,
      required: true,
    },
    domainScrapeFinished: {
      type: [Boolean, Number],
      required: false,
      default: null,
    },
    modalTitle: {
      type: String,
      required: false,
      default: 'Add website',
    },
    modalSubtitle: {
      type: String,
      required: false,
      default: 'AI will extract data from the added website and links.',
    },
  },
  data() {
    return {
      edited: false,
      SBColors,
      SBIconList,
      initialized: false,
      collapsed: true,
      statuses: {},
      rescrape: {
        title: '',
        value: null,
        options: [],
      },
      radioSelected: {
        value: 1,
        options: [],
      },
      entireWeb: {
        action: null,
        delete: false,
        title: '',
        value: null,
        validators: null,
        info: '',
        placehlder: '',
      },
      specificLinksList: {
        value: [],
        title: '',
        subtitle: '',
        info: '',
        addButtonText: '',
        placeholder: '',
        validators: '',
        validatorMessages: {},
        enter: '',
        minButtons: 0,
        maxButtons: null,
      },
      includeLinksList: {
        value: null,
        title: '',
        subtitle: '',
        addButtonText: '',
        placeholder: '',
        validators: '',
        validatorMessages: {},
        enter: '',
        minButtons: 0,
        maxButtons: null,
      },
      excludeLinksList: {
        value: null,
        title: '',
        subtitle: '',
        addButtonText: '',
        placeholder: '',
        validators: '',
        validatorMessages: {},
        enter: '',
        minButtons: 0,
        maxButtons: null,
      },
      entireWebScrapePagination: {
        value: null,
        title: '',
        endpoint: '',
        searchTag: '',
        remoteDataKey: '',
        count: 0,
        maxLinks: 0,
        readOnly: false,
      },
      specificScrapePagination: {
        value: null,
        title: '',
        endpoint: '',
        searchTag: '',
        remoteDataKey: '',
        count: 0,
        maxLinks: 0,
        readOnly: false,
      },
    };
  },
  computed: {
    ...mapGetters({}),
    markedItems() {
      const radioHasChanges = [];
      // entireWeb section
      // if (this.entireWeb.value || (this.includeLinksList.value && this.includeLinksList.value.filter(v => v).length) || (this.excludeLinksList.value && this.excludeLinksList.value.filter(v => v).length) || !this.emptyEntireWebLinksPagination) {
      if (this.entireWeb.value) {
        radioHasChanges.push(1);
      }
      // specificLinks section
      if ((this.specificLinksList.value && this.specificLinksList.value.filter(v => v).length) || !this.emptySpecificLinksPagination) {
        radioHasChanges.push(2);
      }
      return radioHasChanges;
    },
    allValid() {
      return !Object.keys(this.statuses).length || Object.values(this.statuses).every(status => status.valid);
    },
    entireWebValidators() {
      let validators = this.entireWeb.validators;
      if ((this.elements.url && this.elements.url.value && !this.entireWeb.delete)) {
        validators += '|required';
      }
      return validators;
    },
    showEntireWebScrape() {
      return (
        !this.entireWeb.delete && (
          this.domainScrapeFinished &&
          this.entireWebScrapePagination.count >= 0 &&
          (!this.entireWebScrapePagination.value || (this.entireWebScrapePagination.value && (this.entireWebScrapePagination.count - this.entireWebScrapePagination.value.length) > 0)) &&
          this.radioSelected.value === 1
        )
      );
    },
    showEntireWebAction() {
      return this.showEntireWebScrape || (this.elements.url.value && !this.entireWeb.delete);
    },
    emptyEntireWebLinksPagination() {
      return this.entireWeb.delete || !this.entireWebScrapePagination.count || (this.entireWebScrapePagination.value && (this.entireWebScrapePagination.count - this.entireWebScrapePagination.value.length) === 0);
    },
    emptySpecificLinksPagination() {
      return !this.specificScrapePagination.count || (this.specificScrapePagination.value && (this.specificScrapePagination.count - this.specificScrapePagination.value.length) === 0);
    },
    filtersEmpty() {
      return (!this.includeLinksList.value || !this.includeLinksList.value.filter(v => v).length) && (!this.excludeLinksList.value || !this.excludeLinksList.value.filter(v => v).length);
    },
  },
  watch: {
    'rescrape.value': function f() {
      if (!this.initialized) return;
      // console.log('------ rescrape', n, o);
      this.edited = true;
    },
    'entireWeb.value': function f() {
      if (!this.initialized) return;
      // console.log('------ entireWeb', n, o);
      this.edited = true;
    },
    'includeLinksList.value': function f() {
      if (!this.initialized) return;
      // console.log('------ includeLinksList', n, o);
      this.edited = true;
    },
    'excludeLinksList.value': function f() {
      if (!this.initialized) return;
      // console.log('------ excludeLinksList', n, o);
      this.edited = true;
    },
    'entireWebScrapePagination.value': function f() {
      if (!this.initialized) return;
      // console.log('------ entireWebScrapePagination', n, o);
      this.edited = true;
    },
    'specificLinksList.value': function f() {
      if (!this.initialized) return;
      // console.log('------ specificLinksList', n, o);
      this.edited = true;
    },
    'specificScrapePagination.value': function f() {
      if (!this.initialized) return;
      // console.log('------ specificScrapePagination', n, o);
      this.edited = true;
    },
    filtersEmpty() {
      if (!this.initialized) return;
      if (!this.filtersEmpty && this.$refs.entireWebInputRef) {
        setTimeout(() => {
          this.$refs.entireWebInputRef.validate();
        }, 20);
      }
    },
  },
  mounted() {
    this.initialize();

    this.$nextTick(() => {
      this.initialized = true;
      this.emitData();
    });

    this.$root.$on('bv::collapse::state', (collapseId, shown) => {
      if (collapseId === 'collapse-filters') {
        this.collapsed = !shown;
      }
    });
  },
  methods: {
    ...mapActions({}),
    setStatus(status, elementName) {
      this.$set(this.statuses, elementName, status);
    },
    reset() {},
    show() {
      this.$refs.urlInputModal.show();
    },
    clear() {
      this.$emit('closed');
      this.edited = false;
    },
    cancel() {
      this.$emit('reset');
    },
    hide() {
      if (this.$refs.urlInputModal) this.$refs.urlInputModal.hide();
    },
    initialize() {
      // Radio
      if (this.elements && this.elements.radio) {
        this.radioSelected.options = this.elements.radio.options ? this.elements.radio.options : [];
      }

      // Rescrape
      if (this.elements && this.elements.rescrape) {
        this.rescrape.value = this.elements.rescrape.value;
        this.rescrape.title = this.elements.rescrape.title;
        this.rescrape.info = this.elements.rescrape.subtitle;
        this.rescrape.options = this.elements.rescrape.options ? this.elements.rescrape.options : [];
      }

      // Entire Web
      if (this.elements && this.elements.url) {
        this.entireWeb.action = {
          buttonText: this.elements.url.actionButton.text, // this.elements.url.actionButtonText,
          buttonIcon: this.elements.url.actionButton.icon,
          buttonVariant: this.elements.url.actionButton.variant,
          run: () => {
            this.inputAction(this.elements.url.actionButton.action);
          },
        };
        this.entireWeb.delete = false;
        this.entireWeb.title = this.elements.url.title;
        this.entireWeb.value = this.elements.url.value;
        this.entireWeb.validators = this.elements.url.validators;
        this.entireWeb.info = this.elements.url.subtitle;
        this.entireWeb.placeholder = this.elements.url.placeholder;
      }

      // Filters
      //    Include Links
      if (this.elements && this.elements.filters && this.elements.filters.includePaths) {
        this.includeLinksList.value = this.elements.filters.includePaths.value;
        this.includeLinksList.title = this.elements.filters.includePaths.title;
        this.includeLinksList.subtitle = this.elements.filters.includePaths.subtitle;
        this.includeLinksList.addButtonText = this.elements.filters.includePaths.addButtonText;
        this.includeLinksList.placeholder = this.elements.filters.includePaths.placeholder;
        this.includeLinksList.validators = this.elements.filters.includePaths.validators;
        this.includeLinksList.validatorMessages = this.elements.filters.includePaths.validatorMessages;
        this.includeLinksList.enter = this.elements.filters.includePaths.enter;
        this.includeLinksList.minButtons = this.elements.filters.includePaths.minButtons;
        this.includeLinksList.maxButtons = this.elements.filters.includePaths.maxButtons;
      }
      //    Exclude Links
      if (this.elements && this.elements.filters && this.elements.filters.excludePaths) {
        this.excludeLinksList.value = this.elements.filters.excludePaths.value;
        this.excludeLinksList.title = this.elements.filters.excludePaths.title;
        this.excludeLinksList.subtitle = this.elements.filters.excludePaths.subtitle;
        this.excludeLinksList.addButtonText = this.elements.filters.excludePaths.addButtonText;
        this.excludeLinksList.placeholder = this.elements.filters.excludePaths.placeholder;
        this.excludeLinksList.validators = this.elements.filters.excludePaths.validators;
        this.excludeLinksList.validatorMessages = this.elements.filters.excludePaths.validatorMessages;
        this.excludeLinksList.enter = this.elements.filters.excludePaths.enter;
        this.excludeLinksList.minButtons = this.elements.filters.excludePaths.minButtons;
        this.excludeLinksList.maxButtons = this.elements.filters.excludePaths.maxButtons;
      }

      // Entire web scraped links pagination
      if (this.elements && this.elements.domainCrawledLinksPagination) {
        this.entireWebScrapePagination.title = this.elements.domainCrawledLinksPagination.title;
        this.entireWebScrapePagination.endpoint = this.elements.domainCrawledLinksPagination.endpoint;
        this.entireWebScrapePagination.searchTag = this.elements.domainCrawledLinksPagination.searchTag;
        this.entireWebScrapePagination.remoteDataKey = this.elements.domainCrawledLinksPagination.remoteDataKey;
        this.entireWebScrapePagination.count = this.elements.domainCrawledLinksPagination.count;
        this.entireWebScrapePagination.maxLinks = this.elements.domainCrawledLinksPagination.maxLinks;
        this.entireWebScrapePagination.readOnly = this.elements.domainCrawledLinksPagination.readOnly;
      }

      // Specific Links
      if (this.elements && this.elements.pathList) {
        this.specificLinksList.value = this.elements.pathList.value;
        this.specificLinksList.title = this.elements.pathList.title;
        this.specificLinksList.subtitle = this.elements.pathList.subtitle;
        this.specificLinksList.info = this.elements.pathList.subtitle;
        this.specificLinksList.addButtonText = this.elements.pathList.addButtonText;
        this.specificLinksList.placeholder = this.elements.pathList.placeholder;
        this.specificLinksList.validators = this.elements.pathList.validators;
        this.specificLinksList.validatorMessages = this.elements.pathList.validatorMessages;
        this.specificLinksList.enter = this.elements.pathList.enter;
        this.specificLinksList.minButtons = this.elements.pathList.minButtons;
        this.specificLinksList.maxButtons = this.elements.pathList.maxButtons;
      }

      // Specific web scraped links pagination
      if (this.elements && this.elements.specificScrapedLinksPagination) {
        this.specificScrapePagination.title = this.elements.specificScrapedLinksPagination.title;
        this.specificScrapePagination.endpoint = this.elements.specificScrapedLinksPagination.endpoint;
        this.specificScrapePagination.searchTag = this.elements.specificScrapedLinksPagination.searchTag;
        this.specificScrapePagination.remoteDataKey = this.elements.specificScrapedLinksPagination.remoteDataKey;
        this.specificScrapePagination.count = this.elements.specificScrapedLinksPagination.count;
        this.specificScrapePagination.maxLinks = this.elements.specificScrapedLinksPagination.maxLinks;
        this.specificScrapePagination.readOnly = this.elements.specificScrapedLinksPagination.readOnly;
      }
    },
    inputAction(action) {
      if (action && action.toLowerCase() === 'clear') {
        this.entireWeb.value = '';
        this.entireWeb.delete = this.elements.url.value;
      }
    },
    buildDataFormat() {
      const mapper = {
        url: 'entireWeb',
        includePaths: 'includeLinksList',
        excludePaths: 'excludeLinksList',
        rescrape: 'rescrape',
        domainCrawledLinksPagination: 'entireWebScrapePagination',
        specificScrapedLinksPagination: 'specificScrapePagination',
        pathList: 'specificLinksList',
      };
      const body = {};
      const recursiveElements = (elements, currentBodyPosition = body) => {
        Object.keys(elements).forEach((key) => {
          if (elements[key].returnProperties) {
            currentBodyPosition[key] = {};
            elements[key].returnProperties.forEach((prop) => {
              let targetValue = this[mapper[key]][prop];
              if (Array.isArray(targetValue)) {
                targetValue = targetValue.filter(v => v);
              }
              currentBodyPosition[key][prop] = targetValue;
            });
          } else if (typeof elements[key] === 'object') {
            currentBodyPosition[key] = {};
            recursiveElements(elements[key], currentBodyPosition[key]);
            if (this.emptyObject(currentBodyPosition[key])) {
              delete currentBodyPosition[key];
            }
          }
        });
      };
      recursiveElements(this.elements);
      return body;
    },
    emitData() {
      // console.log(this.elements.url.returnProperties);
      // console.log(this.elements.filters.includePaths.returnProperties);
      // console.log(this.elements.filters.excludePaths.returnProperties);
      // console.log(this.elements.rescrape.returnProperties);
      // console.log(this.elements.pathList.returnProperties);
      // console.log(this.elements.domainCrawledLinksPagination.returnProperties);
      // console.log(this.elements.specificScrapedLinksPagination.returnProperties);

      // console.log(this.entireWeb.value);
      // console.log(this.includeLinksList.value);
      // console.log(this.excludeLinksList.value);
      // console.log(this.rescrape.value);
      // console.log(this.specificLinksList.value);
      // console.log(this.entireWebScrapePagination.value);
      // console.log(this.specificScrapePagination.value);

      try {
        this.$emit('input', {
          value: {
            entireWeb: { value: this.entireWeb.value ? this.entireWeb.value : null, delete: this.entireWeb.delete, returnProperties: this.elements.url.returnProperties },
            includePaths: { value: this.entireWeb.value && this.includeLinksList.value && this.includeLinksList.value.filter(v => v) && this.includeLinksList.value.filter(v => v).length ? this.includeLinksList.value.filter(v => v) : null, returnProperties: this.elements.filters.includePaths.returnProperties },
            excludePaths: { value: this.entireWeb.value && this.excludeLinksList.value && this.excludeLinksList.value.filter(v => v) && this.excludeLinksList.value.filter(v => v).length ? this.excludeLinksList.value.filter(v => v) : null, returnProperties: this.elements.filters.excludePaths.returnProperties },
            rescrape: { value: this.rescrape.value, returnProperties: this.elements.rescrape.returnProperties },
            specificLinks: { value: this.specificLinksList.value && this.specificLinksList.value.filter(v => v) && this.specificLinksList.value.filter(v => v).length ? this.specificLinksList.value.filter(v => v) : null, returnProperties: this.elements.pathList.returnProperties },
            removedLinks: { value: this.entireWebScrapePagination.value, returnProperties: this.elements.domainCrawledLinksPagination.returnProperties },
            removedSpecificLinks: { value: this.specificScrapePagination.value, returnProperties: this.elements.specificScrapedLinksPagination.returnProperties },
          },
          children: this.buildDataFormat(),
        });
      } catch (e) {
        // do nothing
      }

      this.hide();
    },
  },
};
</script>

<style lang="scss" scoped>
.subtitle {
  margin-top: 3px !important;
  font-size: 12px !important;
  font-weight: normal !important;
  text-align: left !important;
  color: $blackUltralight !important;
}

::v-deep .modal {
  .modal-content {
    border-radius: 10px !important;
  }

  .modal-header {
    padding: 18px 15px !important;
    h3 {
      font-size: 16px;
      font-weight: 500;
      line-height: 1.2;
    }
    p {
      font-size: 12px;
      font-weight: 400;
      color: $blackUltralight;
    }
  }

  .top-margin-first-child > * {
    margin-bottom: 18px !important;
  }

  .modal-body {
    padding: 15px !important;
    min-height: 200px;

    & > div:last-child,
    & > div:has(+ div[style*="display: none"]) {
      margin-bottom: 0 !important;
    }

    // &.no-bottom-padding {
    //   padding-bottom: 0 !important;
    // }

    .data-loader:first-child {
      margin-top: 90px !important;
    }

    .add-button {
      position: sticky;
      bottom: 0px;
      background: $greyUltralight;
      // margin: 0 -15px;
      padding: 18px 15px;

      * {
        font-size: 14px;
        font-weight: 500;
        color: $blackPrimary;
      }

      > div {
        min-height: 34px;
        padding: 9px 12px;
        border-radius: 10px;
        background: $greyBorderSecondary;
        // cursor: pointer;
        &:hover {
          background-color: #DDE6E9;
        }
      }
    }

    #collapse-filters div:last-of-type {
      margin-bottom: 0 !important;
    }
  }

  .modal-footer {
    button {
      border-radius: 10px;

      &.btn-secondary {
        border: solid 1px $greyBorder;
      }
    }
  }
}
</style>
